<template>
    <div class="card mb-3">
        <div class="card-header">
            <strong>Personnel Fields ({{ personnel.length }})</strong>
        </div>
        <div class="card-body">
            <div class="row mb-2" v-for="field in personnel">
                <div class="col-lg-3 text-muted text-lg-right">{{ field.field_label }}:</div>
                <div class="col-lg-6">
                    <span class="badge badge-danger" v-if="field.is_required === 1">Required</span>
                    <span class="badge badge-default" v-else>Optional</span>

                    <span class="badge badge-info" v-if="field.is_allow_other === 1">Allow Other</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            personnel: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {

            }
        },

        computed: {


        },

        methods: {

        },

        mounted(){
            //Set the personnel that was passed it?
        }
    }
</script>
